import { gikClassPrefix } from '@gik/core/constants';
import { Button } from '@gik/ui/Button';
import classnames from 'classnames';
import React from 'react';

const blockName = `${gikClassPrefix}-contact-tile`;

export interface IContactTileProps {
  title: string;
  buttonText?: string;
  buttonAction?: () => void;
  buttonLink?: string;
  className?: string;
}

export default function ContactTile({
  title,
  children,
  buttonText,
  buttonAction,
  buttonLink,
  className,
}: React.PropsWithChildren<IContactTileProps>) {
  const classNames = classnames([blockName, className]);

  return (
    <div className={classNames}>
      <div className={`${blockName}__title`}>{title}</div>
      <div className={`${blockName}__content`}>{children}</div>
      {buttonText && buttonAction && <Button onClick={buttonAction}>{buttonText}</Button>}
      {buttonText && buttonLink && (
        <Button type="a" href={buttonLink} target="_blank">
          {buttonText}
        </Button>
      )}
    </div>
  );
}
